import type { Logger } from "@expert/logging";

import type { ChallengeInfo } from "@/sales-tools/challenges/api/getChallengesForEmployee";

import { findMyTeam } from "@/sales-tools/challenges/utils/findMyTeam";
import { isDisqualified } from "@/sales-tools/challenges/utils/isDisqualified";
import { userCache } from "@/shared-utils";

/*
 * Given an array of challenges:
 * 1. Sort the challenges by startDate
 * 2. Find the first challenge where:
 *    - The challenge end has not been acknowledged (announcement is undefined or ackEnd is not true)
 *    - The challenge is not a quiz type
 *    - The user is not disqualified based on their conditions
 */
export const findFirstActiveChallenge = (logger: Logger, challenges: ChallengeInfo[] | null | undefined) => {
    return challenges
        ?.sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime())
        .find(
            (c) =>
                (c.announcement === undefined || c.announcement.ackEnd !== true) &&
                c.challengeType !== "quiz" &&
                !isDisqualified(findMyTeam(logger, c.details, userCache.employeeId!).conditions),
        );
};
